import React from 'react';

interface DataItem {
  value: string;
  label: string;
  icon: React.ReactNode;
  gradientFrom: string;
  gradientTo: string;
  onClick?: () => void;
}

interface DataListProps {
  items: DataItem[];
}

const DataList = ({ items }: DataListProps) => {
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <div
              key={index}
              onClick={item.onClick}
              className="relative text-center space-y-3 p-6 rounded-2xl bg-white border border-gray-200 cursor-pointer"
            >
              {/* Icon */}
              <div
                className="flex-shrink-0 flex items-center justify-center mx-auto"
                style={{ width: 52, height: 52 }}
              >
                <div style={{ color: '#FA832E', transform: 'scale(2)', transformOrigin: 'center' }}>{item.icon}</div>
              </div>

              {/* Value */}
              <div className="text-4xl font-bold text-[#263238]">
                {item.value}
              </div>

              {/* Label */}
              <div className="text-sm text-[#728F8B] font-medium">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DataList;

